"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Medical;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Medical(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "48",
    height: "60",
    viewBox: "0 0 48 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group 838"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector",
    d: "M44.6103 11.8204V29.8204C44.6103 51.8204 22.6103 58.9204 22.6103 58.9204C22.6103 58.9204 1.00036 51.9204 1.00036 29.7004V3.2904C0.99494 2.98818 1.05047 2.688 1.16363 2.40771C1.27679 2.12742 1.44526 1.87279 1.65899 1.65905C1.87273 1.44532 2.12733 1.27686 2.40762 1.16369C2.6879 1.05053 2.98812 0.994939 3.29034 1.00036H42.3404C42.6426 0.994939 42.9428 1.05053 43.2231 1.16369C43.5034 1.27686 43.758 1.44532 43.9717 1.65905C44.1854 1.87279 44.3539 2.12742 44.4671 2.40771C44.5803 2.688 44.6358 2.98818 44.6304 3.2904M36.8404 22.9104H26.9203V13.3704H18.6904V22.9104H8.77035V30.8304H18.6904V40.3704H26.9203V30.8304H36.8404V22.9104Z",
    stroke: "#002E6B",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_2",
    d: "M44.6103 8.42969C45.4829 8.42969 46.3197 8.77632 46.9367 9.39331C47.5537 10.0103 47.9003 10.8472 47.9003 11.7197C47.9017 12.1526 47.8175 12.5815 47.6528 12.9818C47.488 13.3821 47.2459 13.7459 46.9403 14.0525C46.6346 14.3591 46.2715 14.6023 45.8717 14.7683C45.4719 14.9343 45.0432 15.0197 44.6103 15.0197C44.1774 15.0197 43.7488 14.9343 43.349 14.7683C42.9492 14.6023 42.586 14.3591 42.2804 14.0525C41.9748 13.7459 41.7326 13.3821 41.5679 12.9818C41.4031 12.5815 41.319 12.1526 41.3203 11.7197C41.3203 10.8472 41.667 10.0103 42.284 9.39331C42.9009 8.77632 43.7378 8.42969 44.6103 8.42969Z",
    fill: "#4DC7EB"
  })));
}